import { API_BASE_URL } from '../config';


// function transformData(data) {
//   const fd = new FormData();

//   if (!data) return fd;

//   Object.entries(data).forEach(([key, value]) => {
//     if (value instanceof FileList) {
//       if (value.length === 1) {
//         fd.append(key, value[0]);
//       } else {
//         Array.from(value).forEach((file, index) => {
//           fd.append(`${key}_${index}`, file);
//         });
//       }
//     } else if (value instanceof Blob) {
//       fd.append(key, value);
//     } else if (typeof value === "object" && value !== null) {
//       Object.entries(value).forEach(([subkey, subvalue]) => {
//         fd.append(`${key}[${subkey}]`, subvalue);
//       });
//     } else {
//       fd.append(key, value);
//     }
//   });

//   return fd;
// }


export async function getCgv(token, language) {
    try {
      // Fetch CGV data first
      const response = await fetch(`${API_BASE_URL}users/cgvs`, {
        method: "GET",
        headers: {
          "Accept-Language": language,
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        cache: "no-cache",
      });
  
      if (!response.ok) {
        throw new Error("Failed to fetch CGV data");
      }
  
      const json = await response.json();
      const data = json.data;
  
      // If the data contains document_url, fetch the file from the URL
      if (data.document_url) {
        const file = await urlToFile(data.document_url, "TermsAndCondtions.pdf");
        data.document = file; // Attach the file to the data object
      }
  
      return data;
    } catch (error) {
      console.error("Error fetching CGV data:", error);
      throw error;
    }
  }
  
  // Convert the document URL to a File object
  async function urlToFile(pdfUrl, fileName) {
    try {
      // Fetch the PDF data from the URL
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
  
      // Convert the Blob into a File object (optional)
      const file = new File([blob], fileName, { type: "application/pdf" });
  
      return file;
    } catch (error) {
      console.error("Error fetching PDF:", error);
      throw error;
    }
  }
  


export async function createCgv(data, token, language = "fr") {
    try {
      const formData = new FormData();
    
      // Append fields, including null or empty values as empty strings
      formData.append("condition_days_1", data.condition_days_1 || "");
      formData.append("condition_days_2", data.condition_days_2 || "");
      formData.append("condition_days_3", data.condition_days_3 || "");
      formData.append("condition_taux_1", data.condition_taux_1 || "");
      formData.append("condition_taux_2", data.condition_taux_2 || "");
      formData.append("condition_taux_3", data.condition_taux_3 || "");
    //   formData.append("document_url", data.document_url || "");
    
      // Append file if present
      if (data.document) {
        formData.append("document", data.document);
      }
  
      const response = await fetch(`${API_BASE_URL}users/cgvs`, {
        method: "POST",
        headers: {
          "Accept-Language": language,
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: formData, // Send formData as the body
      });
  
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error?.errors?.[0]?.message || "Failed to create or update CGV data");
      }
  
      return await response.json();
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  
  
